export function P({ children }) {
  return <p className="text-xl mb-4">{children}</p>;
}

export function A({ children, href }) {
  return (
    <a className="text-indigo-500 hover:underline" href={href}>
      {children}
    </a>
  );
}

export function Code({ children }) {
  return <code className="bg-blue-100 rounded px-2">{children}</code>;
}
